<template>
    <div class="de-liquid-part">
        <liquid :data="percent" :radius="radius" :font-obj="liquidFontObj"></liquid>
        <div class="text" :style="{'margin-left': `${margin}px`}">
            <p class="word" :style="titleStyle">{{title}}</p>
            <p class="num" :style="titleStyle">{{total | formatAmount}}</p>
        </div>
    </div>
</template>

<script>
import Liquid from '../liquid';

export default {
    name: 'de-liquid-part',
    components: {
        Liquid
    },
    props: {
        percent: {
            type: Number,
            default: 50
        },
        radius: {
            type: Number
        },
        title: {
            type: String,
            default: '京津冀'
        },
        total: {
            type: Number,
            default: 5623
        },
        liquidFontObj: {
            type: Object
        },
        titleFontObj: {
            type: Object
        },
        lineHeight: {
            type: Number,
            default: 46
        },
        margin: {
            type: Number,
            default: 16
        }
    },
    computed: {
        titleStyle() {
            return (this.titleFontObj && this.lineHeight)
            ? (Object.assign({}, this.titleFontObj, {
                fontSize: `${this.titleFontObj.fontSize}px`,
                fontFamily: this.titleFontObj.fontFamily,
                fontWeight: this.titleFontObj.fontWeight,
                color: this.titleFontObj.color,
                fontStyle: this.titleFontObj.fontStyle,
                lineHeight: `${this.lineHeight}px`
            }))
            : {};
        }
    }
}
</script>

<style lang="less" scoped>
.de-liquid-part {
    display: flex;
    .circle {
        width: 130px;
        height: 130px;
        line-height: 100px;
    }
    .text {
        // margin-left: 20px;
        padding-top: 22px;
        .word {
            font-family: 'PingFangSC-Regular';
            font-size: 20px;
            color: rgba(255,255,255,0.75);
        }
        .num {
            font-family: 'AgencyFB-Reg';
            font-size: 18px;
            color: #FFF;
        }
    }
}
</style>